import React from 'react';
import { all, any, propEq } from 'ramda';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { errorMessage, successMessage } from '../../../../utils/messageMutation';

const UploadButton = ({
  scope,
  offerId,
  reFetch
}) => {
  return (
    <Upload
      multiple
      name="file"
      accept="application/pdf"
      action="/files/upload"
      showUploadList={false}
      data={{
        scope,
        offerId
      }}
      onChange={(info) => {
        const allFilesDone = all(propEq('done', 'status'))(info.fileList);
        const hasError = any(propEq('error', 'status'))(info.fileList);

        if (allFilesDone) {
          successMessage('fichier', 'téléchargé', false, false, true);
          reFetch();
        } else if (hasError) {
          errorMessage();
        }
      }}
    >
      <Button icon={<UploadOutlined className="text-xs" />}>
        Importer des documents
      </Button>
    </Upload>
  );
};

export default UploadButton;
